module.exports = __webpack_public_path__ + "static/media/blog_1.6521d832.jpg";